import React from 'react';
const {
  DEFAULT_SEO_CONTENT,
  SEO_FAQ_ITEMS,
  SEO_PROJECT_NOTE,
  SEO_USE_CASES,
  getRelatedLandingPages,
  resolveSeoContent,
} = require('../../seo/seoContent');

export const seoUseCases = SEO_USE_CASES;
export const seoFaqItems = SEO_FAQ_ITEMS;
export const defaultSeoContent = DEFAULT_SEO_CONTENT;

function PrivacyText({ text }) {
  const linkText = 'política de privacitat';
  const [before, after] = text.split(linkText);

  if (after === undefined) {
    return text;
  }

  return (
    <>
      {before}
      <a href="/privacy">{linkText}</a>
      {after}
    </>
  );
}

function SeoBlockHeading({ content }) {
  return (
    <div className="seo-content-block-heading">
      <p className="seo-content-block-kicker">{content.kicker}</p>
      <h2 id="seo-content-block-title" className="seo-content-block-title">
        {content.contentTitle}
      </h2>
      <p className="seo-content-block-intro">{content.contentIntro}</p>
    </div>
  );
}

function UseCasesList({ useCases }) {
  return (
    <div className="seo-content-block-usecase-column">
      <h3>Usos habituals</h3>
      <ul className="seo-content-block-usecases">
        {useCases.map((useCase) => (
          <li key={useCase.title}>
            <strong>{useCase.title}</strong>
            <span>{useCase.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function ExplainerCopy({ content }) {
  return (
    <div className="seo-content-block-copy-column">
      <h3>{content.howItWorksTitle}</h3>
      <p>{content.howItWorksText}</p>
      <h3>{content.resultTitle}</h3>
      <p>{content.resultText}</p>
    </div>
  );
}

function PrivacyNote({ content }) {
  return (
    <div className="seo-content-block-privacy-note">
      <h3>{content.privacyTitle}</h3>
      <p>
        <PrivacyText text={content.privacyText} />
      </p>
    </div>
  );
}

function RelatedPagesNav({ relatedLandingPages }) {
  return (
    <nav className="seo-content-block-related-pages" aria-labelledby="seo-content-block-related-title">
      <h3 id="seo-content-block-related-title">Pàgines relacionades</h3>
      <ul>
        {relatedLandingPages.map((page) => (
          <li key={page.path}>
            <a href={page.path}>{page.heading}</a>
            <span>{page.primaryKeyword}</span>
          </li>
        ))}
      </ul>
    </nav>
  );
}

function FaqList() {
  return (
    <div className="seo-content-block-faq" aria-labelledby="seo-content-block-faq-title">
      <h3 id="seo-content-block-faq-title" className="seo-content-block-faq-title">
        Preguntes freqüents
      </h3>
      <dl className="seo-content-block-faq-list">
        {SEO_FAQ_ITEMS.map((item) => (
          <div className="seo-content-block-faq-item" key={item.question}>
            <dt>{item.question}</dt>
            <dd>{item.answer}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

function ProjectNote() {
  return (
    <div className="seo-content-block-project-note">
      <h3>{SEO_PROJECT_NOTE.title}</h3>
      <p>{SEO_PROJECT_NOTE.text}</p>
    </div>
  );
}

function SeoContentBlock({ landingPage }) {
  const content = resolveSeoContent(landingPage);
  const relatedLandingPages = getRelatedLandingPages(landingPage);

  return (
    <section className="seo-content-block-root" aria-labelledby="seo-content-block-title">
      <SeoBlockHeading content={content} />

      <div className="seo-content-block-body">
        <UseCasesList useCases={content.useCases} />
        <ExplainerCopy content={content} />
      </div>

      <PrivacyNote content={content} />
      <RelatedPagesNav relatedLandingPages={relatedLandingPages} />
      <FaqList />
      <ProjectNote />
    </section>
  );
}

export default SeoContentBlock;
